export const createStyles = (theme: any, hasTags: boolean) => ({
  tagRow: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 1,
    width: '100%',
  },
  tagIcon: {
    color: 'text.secondary',
    fontSize: '1.5rem',
    mt: hasTags ? 0.25 : 0,
    flexShrink: 0,
  },
  tagList: {
    display: 'flex',
    flex: 1,
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: 1,
    minWidth: 0,
  },
  tagChip: {
    boxSizing: 'border-box',
    display: 'inline-flex',
    flex: '0 0 auto',
    width: 'fit-content',
    height: 24,
    minHeight: 24,
    maxHeight: 24,
    minWidth: 0,
    maxWidth: 200,
    px: '10px',
    py: '2px',
    backgroundColor: 'transparent',
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: '100px',
    color: theme.palette.text.secondary,
    '& .MuiChip-label': {
      display: 'block',
      flex: '1 1 auto',
      minWidth: 0,
      maxWidth: '100%',
      overflow: 'hidden',
      p: 0,
      lineHeight: '16px',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
    '& .MuiChip-label > .MuiBox-root': {
      minWidth: 0,
      maxWidth: '100%',
      overflow: 'hidden',
    },
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  staticTagChip: {
    cursor: 'default',
  },
  interactiveTagChip: {
    cursor: 'pointer',
  },
  showLessChip: {
    cursor: 'pointer',
    backgroundColor: theme.palette.action.selected,
    borderColor: 'transparent',
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  },
  addTagButton: {
    boxSizing: 'border-box',
    width: 80,
    minWidth: 80,
    maxWidth: 80,
    height: 24,
    minHeight: 24,
    maxHeight: 24,
    px: '10px',
    py: '2px',
    borderRadius: '100px',
    whiteSpace: 'nowrap',
    fontFamily: theme.typography.fontFamily,
    fontWeight: theme.typography.fontWeightRegular,
    fontStyle: 'normal',
    fontSize: '0.8125rem',
    lineHeight: '18px',
    letterSpacing: '0.16px',
  },
  modal: {
    width: 'min(343px, calc(100vw - 32px))',
    maxHeight: 'calc(100vh - 32px)',
    overflowX: 'hidden',
    overflowY: 'auto',
    boxSizing: 'border-box',
    p: 2,
    borderRadius: 2,
    bgcolor: 'background.paper',
    color: 'text.primary',
  },
  modalHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    mb: 1.5,
  },
  modalTitle: {
    fontWeight: theme.typography.fontWeightMedium,
    fontSize: '1.25rem',
    lineHeight: 1.6,
    letterSpacing: '0.15px',
  },
  searchContainer: { position: 'relative' },
  searchField: {
    mt: 0,
    width: '100%',
    '& .MuiFormHelperText-root': { display: 'none' },
  },
  suggestionList: {
    position: 'absolute',
    top: 'calc(100% + 4px)',
    left: 0,
    right: 0,
    zIndex: 1,
    listStyle: 'none',
    m: 0,
    p: 0,
    borderRadius: 1,
    overflow: 'hidden',
    bgcolor: theme.palette.mode === 'dark' ? '#363636' : 'background.paper',
    boxShadow: 4,
  },
  suggestionItem: (isActive = false) => ({
    px: 1.5,
    py: 1.25,
    cursor: 'pointer',
    ...(isActive && { bgcolor: 'action.hover' }),
    '&:hover': { bgcolor: 'action.hover' },
  }),
  newTagLabel: {
    color: theme.palette.primary.main,
    fontWeight: 500,
  },
  selectedTagsTitle: {
    mt: 2,
    mb: 1,
    fontWeight: theme.typography.fontWeightMedium,
    fontSize: '1rem',
    lineHeight: 1.5,
    letterSpacing: '0.15px',
  },
  selectedTags: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 0.75,
  },
  selectedTagChip: {
    boxSizing: 'border-box',
    minWidth: 0,
    maxWidth: 200,
    '& .MuiChip-label': {
      display: 'block',
      flex: '1 1 auto',
      minWidth: 0,
      maxWidth: '100%',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
    '& .MuiChip-label > .MuiBox-root': {
      minWidth: 0,
      maxWidth: '100%',
      overflow: 'hidden',
    },
    borderColor: theme.palette.divider,
    backgroundColor: 'transparent',
    color: 'text.secondary',
    '&& .MuiChip-deleteIcon': {
      color: 'action.disabled',
      '&:hover': { color: 'text.secondary' },
    },
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: 1.5,
    mt: 2,
    pt: 2,
    borderTop: `1px solid ${theme.palette.divider}`,
  },
});
